import React from 'react';
import styled from 'styled-components';

import { TextButton } from '@xingternal/button';
import { IconArrowLeft } from '@xingternal/icons';
import { spaceL } from '@xingternal/tokens';

type Props = {
  title: React.ReactNode;
  to?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

const StyledButton = styled(TextButton)`
  margin: ${spaceL} 0;
  margin-right: auto;
`;

export const NavigationBackButton: React.FC<Props> = ({ title, to, size = 'medium', className }) => {
  return (
    <StyledButton size={size} icon={IconArrowLeft} to={to} className={className}>
      {title}
    </StyledButton>
  );
};
